import React from "react";

const Pulse = ({ className = "" }) => (
  <div className={`animate-pulse rounded-md bg-[#E5E7EB] ${className}`} />
);

export const TimesheetDetailsTabSkeleton = () => (
  <div className="timesheet-detail-form space-y-3">
    <Pulse className="h-10 w-full rounded-lg" />
    <div className="grid grid-cols-2 gap-2.5 xl:grid-cols-4">
      {Array.from({ length: 4 }).map((_, i) => (
        <div
          key={i}
          className="rounded-xl border border-[#E5E7EB] bg-[#F8FAFC] p-3.5 space-y-3"
        >
          <Pulse className="h-3.5 w-28" />
          <div className="flex gap-2">
            <Pulse className="h-9 flex-1 rounded-lg" />
            <Pulse className="h-9 flex-1 rounded-lg" />
          </div>
          <Pulse className="h-3 w-24" />
        </div>
      ))}
    </div>
    <div className="rounded-xl border border-[#E5E7EB] bg-[#F8FAFC] p-4 space-y-3">
      <Pulse className="h-3.5 w-40" />
      <Pulse className="h-20 w-full rounded-lg" />
      <Pulse className="h-20 w-full rounded-lg" />
    </div>
    <div className="flex justify-end">
      <Pulse className="h-9 w-28 rounded-lg" />
    </div>
  </div>
);

export const TimesheetTasksTabSkeleton = () => (
  <div className="space-y-3">
    <div className="rounded-xl border border-[#E5E7EB] bg-[#F8FAFC] p-4 space-y-3">
      <div className="flex items-center justify-between">
        <div className="space-y-2">
          <Pulse className="h-4 w-28" />
          <Pulse className="h-3 w-44" />
        </div>
        <Pulse className="h-6 w-12 rounded-full" />
      </div>
      <Pulse className="h-1.5 w-full rounded-full" />
    </div>
    {Array.from({ length: 4 }).map((_, i) => (
      <div
        key={i}
        className="flex items-center gap-3 rounded-xl border border-[#E5E7EB] bg-white p-3.5"
      >
        <Pulse className="h-5 w-5 shrink-0 rounded-md" />
        <div className="flex-1 space-y-2">
          <Pulse className="h-3.5 w-3/5" />
          <Pulse className="h-3 w-2/5" />
        </div>
        <Pulse className="h-8 w-20 rounded-lg" />
      </div>
    ))}
  </div>
);

export const TimesheetQuestionsTabSkeleton = () => (
  <div className="space-y-4">
    <div className="space-y-2">
      <Pulse className="h-4 w-36" />
      <Pulse className="h-3 w-56" />
    </div>
    {Array.from({ length: 3 }).map((_, i) => (
      <div
        key={i}
        className="rounded-xl border border-[#E5E7EB] bg-[#F8FAFC] p-4 space-y-3"
      >
        <Pulse className="h-4 w-40" />
        <Pulse className="h-16 w-full rounded-lg" />
      </div>
    ))}
  </div>
);

export const TimesheetTableTabSkeleton = ({ rows = 4 }) => (
  <div className="space-y-3">
    <div className="flex justify-end">
      <Pulse className="h-9 w-48 rounded-lg" />
    </div>
    <div className="overflow-hidden rounded-xl border border-[#E5E7EB]">
      <Pulse className="h-10 w-full rounded-none" />
      {Array.from({ length: rows }).map((_, i) => (
        <Pulse key={i} className="h-12 w-full rounded-none border-t border-[#E5E7EB]" />
      ))}
    </div>
  </div>
);

export const TimesheetAttachmentsTabSkeleton = () => (
  <div className="timesheet-tab-content td-attachments-tab space-y-3">
    <div className="td-section flex flex-col gap-2.5 rounded-xl border border-[#E5E7EB] bg-[#F8FAFC] p-3.5">
      <Pulse className="h-3.5 w-36" />
      <div className="flex items-center gap-2">
        <Pulse className="h-8 w-8 shrink-0 rounded-full" />
        <div className="space-y-1.5">
          <Pulse className="h-3.5 w-28" />
          <Pulse className="h-3 w-20" />
        </div>
      </div>
      <Pulse className="h-[100px] w-full rounded-[10px]" />
    </div>
    <div className="td-section flex flex-col gap-2.5 rounded-xl border border-[#E5E7EB] bg-white p-3.5">
      <div className="flex items-start justify-between gap-3">
        <div className="space-y-2">
          <Pulse className="h-4 w-32" />
          <Pulse className="h-3 w-24" />
        </div>
      </div>
      <div className="td-attachment-grid">
        {Array.from({ length: 3 }).map((_, i) => (
          <Pulse key={i} className="h-[88px] w-[88px] rounded-[10px]" />
        ))}
        <Pulse className="h-[88px] w-[88px] rounded-[10px]" />
      </div>
    </div>
    <div className="td-att-action-strip">
      <Pulse className="h-9 w-24 rounded-[10px]" />
      <Pulse className="h-9 w-28 rounded-[10px]" />
    </div>
  </div>
);

export const TimesheetMedicationTabSkeleton = () => (
  <div className="space-y-3">
    <div className="td-med-filter-row">
      <Pulse className="h-3.5 w-32" />
      <Pulse className="h-[34px] w-[180px] rounded-lg" />
    </div>
    <div className="overflow-hidden rounded-xl border border-[#E5E7EB] bg-white">
      <div className="grid grid-cols-7 gap-3 border-b border-[#E5E7EB] bg-[#F8FAFC] px-3 py-2.5">
        {Array.from({ length: 7 }).map((_, i) => (
          <Pulse key={i} className="h-3 w-16" />
        ))}
      </div>
      {Array.from({ length: 5 }).map((_, i) => (
        <div
          key={i}
          className="grid grid-cols-7 gap-3 border-b border-[#F1F5F9] px-3 py-3 last:border-b-0"
        >
          <Pulse className="h-8 w-24" />
          <div className="space-y-1.5">
            <Pulse className="h-3.5 w-full max-w-[140px]" />
            <Pulse className="h-3 w-20" />
          </div>
          <Pulse className="h-3.5 w-14" />
          <Pulse className="h-6 w-16 rounded-full" />
          <Pulse className="h-3.5 w-28" />
          <Pulse className="h-5 w-5 rounded-md" />
          <Pulse className="h-5 w-5 rounded-md" />
        </div>
      ))}
    </div>
  </div>
);

export const TimesheetLocationTabSkeleton = () => (
  <div className="space-y-3">
    <div className="space-y-2">
      <Pulse className="h-4 w-28" />
      <Pulse className="h-3 w-48" />
    </div>
    <Pulse className="h-64 w-full rounded-xl" />
  </div>
);

export const TimesheetCodeAllocationTabSkeleton = () => (
  <div className="timesheet-code-allocation space-y-3">
    <div className="flex items-center gap-3 rounded-xl border border-[#E5E7EB] bg-white px-3.5 py-2.5">
      <Pulse className="h-3.5 flex-1 max-w-[280px]" />
      <div className="ml-auto space-y-1.5 text-right">
        <Pulse className="h-2.5 w-20 ml-auto" />
        <Pulse className="h-4 w-16 ml-auto" />
      </div>
    </div>
    <div className="flex flex-wrap gap-2">
      {Array.from({ length: 4 }).map((_, i) => (
        <Pulse key={i} className="h-8 w-28 rounded-full" />
      ))}
    </div>
    <div className="flex items-center justify-between gap-3">
      <Pulse className="h-3 w-48" />
      <Pulse className="h-6 w-36 rounded-full" />
    </div>
    <div className="ca-workspace">
      <div className="ca-column space-y-3">
        <div className="ca-section-card space-y-3">
          <Pulse className="h-4 w-36" />
          <div className="flex gap-2">
            <Pulse className="h-9 flex-1 rounded-lg" />
            <Pulse className="h-9 flex-1 rounded-lg" />
          </div>
          <Pulse className="h-12 w-full rounded-lg" />
          <div className="grid grid-cols-2 gap-2">
            <Pulse className="h-9 rounded-lg" />
            <Pulse className="h-9 rounded-lg" />
          </div>
        </div>
        <div className="ca-section-card space-y-3">
          <Pulse className="h-4 w-24" />
          <Pulse className="h-9 w-full rounded-lg" />
        </div>
      </div>
      <div className="ca-column space-y-3">
        <Pulse className="h-10 w-full rounded-lg" />
        <Pulse className="h-24 w-full rounded-lg" />
        <Pulse className="h-24 w-full rounded-lg" />
      </div>
    </div>
    <div className="flex justify-end border-t border-[#E5E7EB] pt-3">
      <Pulse className="h-[38px] w-36 rounded-[10px]" />
    </div>
  </div>
);

export const TimesheetActivityTabSkeleton = () => (
  <div className="space-y-4 p-1">
    <Pulse className="h-4 w-32" />
    {Array.from({ length: 5 }).map((_, i) => (
      <div
        key={i}
        className="flex gap-3 rounded-xl border border-[#E5E7EB] bg-[#F8FAFC] p-3.5"
      >
        <Pulse className="h-8 w-8 shrink-0 rounded-full" />
        <div className="flex-1 space-y-2">
          <Pulse className="h-3.5 w-2/5" />
          <Pulse className="h-3 w-full" />
          <Pulse className="h-3 w-1/3" />
        </div>
      </div>
    ))}
  </div>
);

export const getTimesheetDetailTabSkeleton = (tabId) => {
  switch (tabId) {
    case 1:
      return TimesheetDetailsTabSkeleton;
    case 2:
      return TimesheetTasksTabSkeleton;
    case 3:
      return TimesheetMedicationTabSkeleton;
    case 4:
      return TimesheetAttachmentsTabSkeleton;
    case 5:
      return TimesheetLocationTabSkeleton;
    case 6:
      return TimesheetCodeAllocationTabSkeleton;
    case 8:
      return TimesheetQuestionsTabSkeleton;
    case 9:
      return TimesheetActivityTabSkeleton;
    default:
      return () => null;
  }
};
